<template>
    <div class="saveOrUpdateCrud studentUpdate">
        <div>
            <el-page-header @back="close" content="修改学生信息导入表"></el-page-header>
        </div>
        <el-form :model="upsertForm"  :rules="rules" ref="upsertForm" :inline="true" label-width="80px" style="margin-top: 20px;" >
            <input type="hidden" :value="upsertForm.id">
            <div style="border: dashed 1px #1989FA;height: 265px">
                <div style="height: 30px;">
                    <el-alert title="基础信息" type="success" :closable="false"></el-alert>
                </div>
                <div style="margin-top: 10px">
                    <div style="width: 25%;float: left">
                        <el-form-item label="照片" prop="faceImg">
                            <el-upload
                                    class="el-uploader"
                                    :headers="{token:$store.getters.getToken}"
                                    :action="uploadAvatarUrl"
                                    :show-file-list="false"
                                    :on-progress="avatarUploadProgress"
                                    :on-success="uploadAvatarSuccess"
                                    :on-error="uploadAvatarError"
                                    :before-upload="beforeAvatarUpload"
                                    accept=".jpg,.png">
                                <img v-if="upsertForm.faceImg" :src="config.resPre+upsertForm.faceImg" class="uploader-img">
                                <i v-else class="el-icon-plus el-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <div class="el-upload__tip" slot="tip" style="text-align: left;width: 600px;margin-top: 0px;color: red">说明:480px*640px,文件格式为jpg,文件大小不超过<strong style="color: #fe6a66">40K</strong>，推荐使用学信网学籍照片</div>
                    </div>
                    <div style="width: 75%;float: left" class="longLabeles">
                        <el-form-item label="考生姓名" prop="name">
                            <el-input size="mini" maxlength="20"  placeholder="请输入考生姓名" show-word-limit  v-model="upsertForm.name" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号" prop="idCard">
                            <el-input size="mini" maxlength="18"  placeholder="请输入18位正确的身份证号" show-word-limit  v-model="upsertForm.idCard" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="登录密码" prop="password" v-if="title=='增加'">
                            <el-input type="password" size="mini" maxlength="18"  placeholder="请输入6-18位的密码" show-word-limit  v-model="upsertForm.password" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="出生日期" prop="birthday" v-if="title=='修改'">
                            <el-date-picker
                                    v-model="upsertForm.birthday"
                                    type="date"
                                    size="mini"
                                    placeholder="选择出生日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="性别" prop="sex">
                            <el-select v-model="upsertForm.sex" size="mini" filterable  placeholder="请选择性别">
                                <el-option v-for="item in sexList" :key="item.name" :label="item.name" :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="民族" prop="nation">
                            <el-select v-model="upsertForm.nation" size="mini" filterable  placeholder="请选择民族">
                                <el-option v-for="item in nationList" :key="item.name" :label="item.name" :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="政治面貌" prop="politicalAffiliation">
                            <el-select v-model="upsertForm.politicalAffiliation" size="mini" filterable  placeholder="请选择政治面貌">
                                <el-option v-for="item in politicalAffiliationList" :key="item.name" :label="item.name" :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <div class="addressStyle">
                            <el-form-item label="家庭住址" prop="homeAddress">
                                <el-input size="mini" maxlength="50" style="width: 770px!important;" placeholder="请输入家庭住址" show-word-limit  v-model="upsertForm.homeAddress" auto-complete="off"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
            <div style="border: dashed 1px #1989FA;height: auto;margin-top: 10px" class="phoneLabel">
                <div style="height: 30px;margin-bottom: 8px">
                    <el-alert title="联系电话" type="success" :closable="false"></el-alert>
                </div>
                <el-form-item label="联系电话" prop="phone">
                    <el-input size="mini" maxlength="11" placeholder="请输入联系电话" show-word-limit  v-model="upsertForm.phone" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮编" prop="adressCode">
                    <el-input size="mini" maxlength="10" placeholder="请输入邮编" show-word-limit  v-model="upsertForm.adressCode" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系地址" prop="address">
                    <el-input size="mini" maxlength="50" placeholder="请输入联系地址" style="width: 410px" show-word-limit  v-model="upsertForm.address" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="户籍所在地" prop="permanentAddress">
                    <el-input size="mini" maxlength="50" placeholder="请输入户籍所在地" style="width: 410px" show-word-limit  v-model="upsertForm.permanentAddress" auto-complete="off"></el-input>
                </el-form-item>
            </div>
            <div style="border: dashed 1px #1989FA;height: auto;margin-top: 10px" class="longLabel">
                <div style="height: 30px;margin-bottom: 8px">
                    <el-alert title="报考情况" type="success" :closable="false"></el-alert>
                </div>
                <el-form-item label="毕业学校" prop="univerColleges">
                    <el-select v-model="upsertForm.univerColleges" size="mini" filterable  placeholder="请选择毕业学校" @change="getSchoolMajorList(upsertForm.univerColleges,0)">
                        <el-option v-for="item in univerCollegesList" :key="item.code" :label="item.name" :value="item.code" @click.native="setUniverCollegesCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="毕业专业" prop="studyMajor">
                    <el-input size="mini" maxlength="40" placeholder="请输入毕业专业" show-word-limit  v-model="upsertForm.studyMajor" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="报考学校" prop="studyColleges">
                    <el-input size="mini" maxlength="50" placeholder="请输入报考学校" show-word-limit  v-model="upsertForm.studyColleges" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="报考学校代码" prop="studyCollegesCode">
                    <el-input size="mini" maxlength="10" placeholder="请输入报考学校代码" show-word-limit  v-model="upsertForm.studyCollegesCode" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="报考专业" prop="examMajor">
                    <el-input size="mini" maxlength="40" placeholder="请输入报考专业" show-word-limit  v-model="upsertForm.examMajor" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="报考专业代码" prop="examMajorCode">
                    <el-input size="mini" maxlength="40" placeholder="请输入报考专业代码" show-word-limit  v-model="upsertForm.examMajorCode" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="考生类型" prop="studentType">
                    <el-select v-model="upsertForm.studentType" size="mini" filterable  placeholder="请选择考生类型">
                        <el-option v-for="item in studentTypeList" :key="item.name" :label="item.name" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="建档立卡所在省" prop="archivesCardProvince" v-if="upsertForm.studentType && upsertForm.studentType=='建档立卡'">
                    <el-select v-model="upsertForm.archivesCardProvince" size="mini" filterable  placeholder="请选择建档立卡所在省">
                        <el-option v-for="item in provinceList" :key="item.name" :label="item.name" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="入伍时间" prop="joinArmyTime" v-if="upsertForm.studentType && upsertForm.studentType=='退役士兵'">
                    <el-input size="mini" maxlength="32" placeholder="请输入入伍时间"  show-word-limit  v-model="upsertForm.joinArmyTime" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="退役时间" prop="endArmyTime" v-if="upsertForm.studentType && upsertForm.studentType=='退役士兵'">
                    <el-input size="mini" maxlength="32" placeholder="请输入退役时间"  show-word-limit  v-model="upsertForm.endArmyTime" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="退役安置地" prop="endArmyAdress" v-if="upsertForm.studentType && upsertForm.studentType=='退役士兵'">
                    <el-input size="mini" maxlength="255" placeholder="请输入退役安置地"  show-word-limit  v-model="upsertForm.endArmyAdress" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="入学时间" prop="startStudyTime">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.startStudyTime" placeholder="请输入入学时间" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="毕业时间" prop="endStudyTime">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.endStudyTime" placeholder="请输入毕业时间" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="毕业生类型" prop="graduatesType">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.graduatesType" placeholder="请输入毕业生类型" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="入伍地" prop="enlistmentPlace">
                    <el-input size="mini" maxlength="100" show-word-limit  v-model="upsertForm.enlistmentPlace" placeholder="请输入入伍地" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="入伍类型" prop="enlistmentType">
                    <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.enlistmentType" placeholder="请输入入伍类型" auto-complete="off"></el-input>
                </el-form-item>
            </div>
            <div style="border: dashed 1px #1989FA;height: 200px;margin-top: 10px" class="longLabels">
                <div style="height: 30px;margin-bottom: 8px">
                    <el-alert title="其它信息" type="success" :closable="false"></el-alert>
                </div>
                <el-form-item label="所获奖励" prop="reward">
                    <el-input size="mini" maxlength="500" placeholder="请描述您的所获奖励"  type="textarea" autosize resize="none" style="width: 1020px" show-word-limit  v-model="upsertForm.reward" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="特长" prop="speciality">
                    <el-input size="mini" maxlength="500" placeholder="请描述您的特长"  type="textarea" autosize resize="none" style="width: 1020px" show-word-limit  v-model="upsertForm.speciality" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input size="mini"maxlength="500" placeholder="请输入备注"  type="textarea" autosize resize="none" style="width: 1020px" show-word-limit  v-model="upsertForm.remark" auto-complete="off"></el-input>
                </el-form-item>
            </div>
        </el-form>
        <div class="dialog-footer" style="text-align: right;margin:20px">
            <el-button plain size="mini" @click="close">取 消</el-button>
            <el-button plain size="mini" type="primary" v-if="title=='增加'" v-display:sysStudentIn-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
            <el-button plain size="mini" type="primary" v-else v-display:sysStudentIn-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "saveOrUpdateSysStudentIn",
        props: ['title','id'],
        data(){
            return {
                upsertForm:{
                    id:'',
                    adminId:'',
                    adminName:'',
                    faceImg:'',
                    name:'',
                    studentType:'',
                    birthday:'',
                    sex:'',
                    nation:'',
                    politicalAffiliation:'',
                    idCard:'',
                    archivesCardProvince:'',
                    univerColleges:'',
                    studyMajor:'',
                    studyColleges:'',
                    studyCollegesCode:'',
                    examMajor:'',
                    examMajorCode:'',
                    homeAddress:'',
                    address:'',
                    adressCode:'',
                    phone:'',
                    reward:'',
                    speciality:'',
                    endSchoolCode:'',
                    joinArmyTime:'',
                    endArmyTime:'',
                    endArmyCode:'',
                    endArmyAdress:'',
                    year:'',
                    permanentAddress:'',
                    startStudyTime:'',
                    endStudyTime:'',
                    graduatesType:'',
                    enlistmentPlace:'',
                    enlistmentType:'',
                    updateTime:'',
                    createTime:''
                },
                rules: {
                    sequence: [
                        { required: true, message: '请输入序号', trigger: 'blur' },
                        {  max: 8, message: '长度必须少于8个字符', trigger: 'blur' }
                    ],
                    studentId: [
                        { required: true, message: '请输入学号', trigger: 'blur' },
                        {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请输入考生姓名', trigger: 'blur' },
                        {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                    ],
                    idCard: [
                        { required: true, message: '请输入身份证号', trigger: 'blur' },
                        {  max: 18, message: '长度必须少于18个字符', trigger: 'blur' },
                        {
                            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                            message: '身份证号格式有误！',
                            trigger: 'blur'
                        }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        {  max: 18, min:6, message: '长度必须为6-18个字符', trigger: 'blur' }
                    ],
                    birthday: [
                        { required: true, message: '请输入出生日期', trigger: 'blur' },
                    ],
                    sex: [
                        { required: true, message: '请选择性别', trigger: 'blur' },
                    ],
                    nation: [
                        { required: true, message: '请选择民族', trigger: 'blur' },
                    ],
                    politicalAffiliation: [
                        { required: true, message: '请选择政治面貌', trigger: 'blur' },
                    ],
                    faceImg: [
                        { required: true, message: '请上传照片', trigger: 'blur' },
                    ],
                    phone: [
                        { required: true, message: '请输入联系电话', trigger: 'blur' },
                        {  max: 11, message: '长度必须为11个数字', trigger: 'blur' },
                        {  min: 11, message: '长度必须为11个数字', trigger: 'blur' }
                    ],
                    emergencyContact: [
                        { required: true, message: '请输入紧急联系人', trigger: 'blur' },
                        {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                    ],
                    emergencyPhone: [
                        { required: true, message: '请输入紧急联系人方式', trigger: 'blur' },
                        {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                    ],
                    adressCode: [
                        { required: true, message: '请输入邮编', trigger: 'blur' },
                        {  max: 10, message: '长度必须少于10个字符', trigger: 'blur' }
                    ],
                    address: [
                        { required: true, message: '请输入联系地址', trigger: 'blur' },
                        {  max: 50, message: '长度必须少于50个字符', trigger: 'blur' }
                    ],
                    homeAddress: [
                        { required: true, message: '请输入家庭住址', trigger: 'blur' },
                        {  max: 50, message: '长度必须少于50个字符', trigger: 'blur' }
                    ],
                    univerColleges: [
                        { required: true, message: '请输入毕业学校', trigger: 'blur' },
                    ],
                    unicerCollegesCode: [
                        { required: true, message: '请输入毕业学校代码', trigger: 'blur' },
                    ],
                    studyColleges: [
                        { required: true, message: '请输入报考学校', trigger: 'blur' },
                    ],
                    studyCollegesCode: [
                        { required: true, message: '请输入报考学校', trigger: 'blur' },
                    ],
                    studyMajor: [
                        { required: true, message: '请输入毕业专业', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studyMajorId: [
                        { required: true, message: '请选择毕业专业', trigger: 'blur' },
                    ],
                    studyMajorCode: [
                        { required: true, message: '请输入毕业专业代码', trigger: 'blur' },
                        {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                    ],
                    examMajor: [
                        { required: true, message: '请输入报考专业', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    majorId: [
                        { required: true, message: '请选择报考专业', trigger: 'blur' },
                    ],
                    studyCode: [
                        { required: true, message: '请输入高考报名', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    reward: [
                        { message: '请描述所获奖励', trigger: 'blur' },
                        {  max: 500, message: '长度必须少于500个字符', trigger: 'blur' }
                    ],
                    speciality: [
                        { message: '请描述特长', trigger: 'blur' },
                        {  max: 500, message: '长度必须少于500个字符', trigger: 'blur' }
                    ],
                    remark: [
                        { message: '请输入备注', trigger: 'blur' },
                        {  max: 500, message: '长度必须少于500个字符', trigger: 'blur' }
                    ],
                    studySequence: [
                        { required: true, message: '请输入报名序号', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    subjectOneId: [
                        { required: true, message: '请选择第一门科目', trigger: 'blur' },
                    ],
                    subjectTwoId: [
                        { required: true, message: '请选择第二门科目', trigger: 'blur' },
                    ],
                    archivesCardProvince: [
                        { required: true, message: '请选择建档立卡所在省', trigger: 'blur' },
                    ],
                    joinArmyTime: [
                        { required: true, message: '请输入入伍时间', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    endArmyTime: [
                        { required: true, message: '请输入退役时间', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    endArmyCode: [
                        { required: true, message: '请输入退役编号', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    endArmyAdress: [
                        { required: true, message: '请输入退役安置地', trigger: 'blur' },
                        {  max: 255, message: '长度必须少于255个字符', trigger: 'blur' }
                    ],
                    studentType: [
                        { required: true, message: '请选择考生类型', trigger: 'blur' },
                    ],
                },
                config:config,
                uploadAvatarUrl:`${home}/sysStudent/uploadAvatar`,
                univerCollegesList:[],
                sexList:[],
                nationList:[],
                politicalAffiliationList:[],
                majorList:[],
                subjectOneList:[],
                subjectTwoList:[],
                schoolMajorList:[],
                studentTypeList:[],
                provinceList:[],
            }
        },
        created(){
            this.getDdList();
            if(this.title=='修改'){
              axios({
                  url:`${home}/sysStudentIn/update/findSysStudentInById/${this.id}`,
                  method:'GET'
              }).then(res=>{
                  Object.assign(this.upsertForm,res.data);
              }).catch(error=>{

              })
            }
        },
        mounted(){

        },
        methods:{
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        axios({
                            url:`${home}/sysStudentIn/${this.title==='增加'?'saveSysStudentIn':'update/updateSysStudentIn'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.title+'成功',
                                type: 'success'
                            });
                            this.$emit('closeSaveOrUpdate',true);
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            close(){
                this.$emit('closeSaveOrUpdate');
            },
            uploadAvatarSuccess(response, file, fileList){
                if(response.result.success){
                    this.upsertForm.faceImg=response.data;
                }else{
                    this.$message.error(response.result.msg);
                }
                loading.close();
            },
            beforeAvatarUpload(file){
                const isJPG = file.type === "image/jpeg" ||
                    file.type === "image/jpg" || file.type === "image/png";
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error("上传头像图片只能是 jpg,png 格式!");
                    return false;
                }
                if (!isLt2M) {
                    this.$message.error("上传头像图片大小不能超过 2MB!");
                    return false;
                }
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },
            avatarUploadProgress(event, file, fileList){

            },
            uploadAvatarError(err, file, fileList){
                loading.close();
            },
            getDdList(){
                axios({
                    url:`${home}/sysDdList/getDdInfoList`,
                    method:'GET'
                }).then(res=>{
                    this.nationList = res.data[0];
                    this.sexList = res.data[1];
                    this.politicalAffiliationList = res.data[2];
                    this.univerCollegesList = res.data[3];
                    this.majorList = res.data[4];
                    this.studentTypeList = res.data[5];
                    this.provinceList = res.data[6];
                }).catch(error=>{

                })
            },
            setUniverCollegesCode(e){
                this.upsertForm.unicerCollegesCode = this.upsertForm.univerColleges;
            },
            setMajorName(e){
                this.upsertForm.examMajor = e.target.innerText;
            },
        }
    }
</script>

<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }
</style>
<style lang="scss">

    .studentUpdate{
        .longLabeles{
            .el-input__inner{
                width: 340px;
            }
            .el-date-editor{
                width: 340px;
            }
        }
        .addressStyle{
            .el-input__inner{
                width: 770px !important;
            }
        }
        .longLabel{
            .el-form-item__label{
                width: 120px !important;
            }
            .el-input__inner{
                width: 255px;
            }

        }
        .longLabels{
            .el-form-item__label{
                width: 120px !important;
            }
        }
        .phoneLabel{
            .el-form-item__label{
                width: 120px !important;
            }
        }
    }

</style>